var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { setErrorMessage } from '@popup/multichain/actions/message.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { MyWitnessTabComponent } from '@popup/steem/pages/app-container/home/governance/my-witness-tab/my-witness-tab.component';
import { ProposalTabComponent } from '@popup/steem/pages/app-container/home/governance/proposal-tab/proposal-tab.component';
import { ProxyTabComponent } from '@popup/steem/pages/app-container/home/governance/proxy-tab/proxy-tab.component';
import { WitnessTabComponent } from '@popup/steem/pages/app-container/home/governance/witness-tab/witness-tab.component';
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import 'react-tabs/style/react-tabs.scss';
import RotatingLogoComponent from 'src/common-ui/rotating-logo/rotating-logo.component';
import { TabsComponent } from 'src/common-ui/tabs/tabs.component';
const Governance = ({ setTitleContainerProperties, setErrorMessage, activeAccount, }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [tabs, setTabs] = useState([]);
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_governance',
            isBackButtonEnabled: true,
        });
        init();
    }, []);
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        let requestResult = [];
        requestResult = yield SteemTxUtils.getData('condenser_api.get_witnesses_by_vote', ['', 250]);
        const ranking = requestResult === null || requestResult === void 0 ? void 0 : requestResult.map((witness, index) => {
            var _a;
            return (Object.assign(Object.assign({}, witness), { rank: (_a = witness.rank) !== null && _a !== void 0 ? _a : index + 1 }));
        });
        let hasError = false;
        if (!requestResult || requestResult.length === 0) {
            hasError = true;
            setErrorMessage('popup_html_error_retrieving_witness_ranking');
        }
        const tempTabs = [
            {
                title: 'popup_html_witness',
                content: React.createElement(WitnessTabComponent, { ranking: ranking, hasError: hasError }),
            },
            {
                title: 'popup_html_proxy',
                content: React.createElement(ProxyTabComponent, null),
            },
            {
                title: 'popup_html_proposal',
                content: React.createElement(ProposalTabComponent, null),
            },
        ];
        if (ranking &&
            ranking.length > 0 &&
            ranking.find((witness) => witness.owner === activeAccount.name) !==
                undefined) {
            tempTabs.push({
                title: 'popup_html_my_witness_page',
                content: React.createElement(MyWitnessTabComponent, { ranking: ranking }),
            });
        }
        setTabs(tempTabs);
        setIsLoading(false);
    });
    return (React.createElement("div", { className: "governance-page", "aria-label": "governance-page" },
        !isLoading && React.createElement(TabsComponent, { tabs: tabs }),
        isLoading && (React.createElement("div", { className: "rotating-logo-container" },
            React.createElement(RotatingLogoComponent, null)))));
};
const mapStateToProps = (state) => {
    return { activeAccount: state.steem.activeAccount };
};
const connector = connect(mapStateToProps, {
    setTitleContainerProperties,
    setErrorMessage,
});
export const GovernanceComponent = connector(Governance);
